<div
  class="userChipWrapper"
  [class.userChip--error]="ppHasError"
  [class.userChipWrapper--disabled]="ppDisabled"
  >
  <div class="userChip" [class.userChip--disabled]="ppDisabled">
    @if (userAvatarSrc) {
      <img ppImage class="userChip__image" [src]="userAvatarSrc" />
    }

    <span class="userChip__username" [class.userChip__username--error]="ppHasError">
      {{ userName }}
    </span>
  </div>

  @if (!ppDisabled) {
    <button
      class="userChip__delete"
      [class.userChip__delete--error]="ppHasError"
      (click)="removeUser($event)"
      >
      <pp-icon
        [ppSrc]="EIconPath.ADVANCED_FILTERS_CLEAR_14"
        ppClass="setSize14"
        ppColor="grey-500"
      ></pp-icon>
    </button>
  }
</div>
